/* eslint-disable */

import React, { Component } from 'react';
import { Button, Table, Input, Icon } from 'semantic-ui-react';
import _ from 'lodash';

import './UserList.css';

class UserList extends Component {
  state = {
    showConfirm: false,
    searchText: '',
    column: null,
    direction: null
  };

  searchUser = (event, { value }) => {
    this.setState({ searchText: value });
  };

  getAttribute = (user, field) => {
    const attribute = user.Attributes.find(
      (attribute) => attribute.Name === field
    );
    return attribute ? attribute.Value : '';
  };

  filteredUsers = () => {
    const { column, direction } = this.state;

    let filteredUsers = this.props.users;
    if (this.state.searchText) {
      filteredUsers = filteredUsers.filter(
        (user) =>
          user.Username.toLowerCase().indexOf(
            this.state.searchText.toLowerCase()
          ) !== -1 ||
          this.getAttribute(user, 'given_name')
            .toLowerCase()
            .indexOf(this.state.searchText.toLowerCase()) !== -1 ||
          this.getAttribute(user, 'family_name')
            .toLowerCase()
            .indexOf(this.state.searchText.toLowerCase()) !== -1
      );
    }

    if (column && direction) {
      if (column === 'Username') {
        filteredUsers = _.orderBy(
          filteredUsers,
          [(user) => user[column].toLowerCase()],
          [direction]
        );
      } else if (column === 'Enabled') {
        filteredUsers = _.orderBy(
          filteredUsers,
          [(user) => user[column]],
          [direction]
        );
      } else {
        filteredUsers = _.orderBy(
          filteredUsers,
          [(user) => this.getAttribute(user, column).toLowerCase()],
          [direction]
        );
      }
    }

    return filteredUsers;
  };

  handleSort = (clickedColumn) => () => {
    const { column, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({ column: clickedColumn, direction: 'asc' });
      return;
    }

    this.setState({ direction: direction === 'asc' ? 'desc' : 'asc' });
  };

  renderArrow = (field) => {
    const { direction, column } = this.state;
    if (column && field === column) {
      if (direction === 'asc') {
        return <Icon name="caret up" size="small" />;
      } else {
        return <Icon name="caret down" size="small" />;
      }
    }

    return <Icon name="caret down" size="small" />;
  };

  editUser = (e, { data }) => {
    this.props.editUser(data.username);
  };

  changeUserStatus = (e, { data }) => {
    this.props.changeUserStatus(data.username, data.enabled);
  };

  render() {
    if (this.props.users) {
      const { direction, column } = this.state;
      return (
        <div>
          <Input
            className="user-search"
            placeholder="Search"
            type="text"
            name="search"
            onChange={this.searchUser}
          />
          <div className="new-user-link">
            <a href="#" onClick={this.props.newUser}>
              NEW USER +
            </a>
          </div>
          <Table sortable celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className="row-name">Name</Table.HeaderCell>
                <Table.HeaderCell
                  className="row-name"
                  sorted={column === 'Username' ? direction : 'desc'}
                  onClick={this.handleSort('Username')}
                >
                  User Name {this.renderArrow('Username')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="row-name"
                  sorted={column === 'email' ? direction : 'desc'}
                  onClick={this.handleSort('email')}
                >
                  Email {this.renderArrow('email')}
                </Table.HeaderCell>
                <Table.HeaderCell
                  className="row-name"
                  sorted={column === 'Enabled' ? direction : 'desc'}
                  onClick={this.handleSort('Enabled')}
                >
                  Status {this.renderArrow('Enabled')}
                </Table.HeaderCell>
                <Table.HeaderCell className="row-operations">
                  Operations
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.filteredUsers().map((user) => (
                <Table.Row key={user.Username}>
                  <Table.Cell>
                    {this.getAttribute(user, 'family_name') +
                      ' ' +
                      this.getAttribute(user, 'given_name')}
                  </Table.Cell>
                  <Table.Cell>{user.Username}</Table.Cell>
                  <Table.Cell>{this.getAttribute(user, 'email')}</Table.Cell>
                  <Table.Cell>
                    {user.Enabled ? (
                      <label className="active-user">Active</label>
                    ) : (
                      <label className="inactive-user">Inactive</label>
                    )}
                  </Table.Cell>
                  <Table.Cell className="column-operations">
                    {this.state.showConfirm &&
                    user.Username === this.state.deleteRowId ? (
                      <div className="div-confirm">
                        <p className="text-confirm">Are you sure?</p>
                        <Button
                          onClick={this.deleteUser}
                          size="mini"
                          color="grey"
                        >
                          Yes
                        </Button>
                        <Button
                          onClick={this.handleCancel}
                          size="mini"
                          color="red"
                        >
                          No
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          data={{ username: user.Username }}
                          onClick={this.editUser}
                          size="small"
                          color="blue"
                          className="button-delete-user operation-button"
                        >
                          Edit
                        </Button>
                        <Button
                          data={{
                            username: user.Username,
                            enabled: user.Enabled
                          }}
                          onClick={this.changeUserStatus}
                          size="small"
                          color="blue"
                          className="button-delete-user operation-button"
                        >
                          {user.Enabled ? 'Disable' : 'Enable'}
                        </Button>
                      </div>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      );
    }
    return null;
  }
}

export default UserList;



// WEBPACK FOOTER //
// ./src/screens/User/UserList.js